import { Component, ViewChild, ViewChildren, QueryList } from '@angular/core';
import { Lifecycle } from 'src/app/_helpers/Lifecycle/Lifecycle.class';
import { APIHeaderService } from '../../_services/header/API-header';
import { formatDate } from '@angular/common';
import { $DBManagerService } from '../../../../_helpers/DB/DBManager.service';
import { Constants } from '../../../../_utils/Constants';
import { $ModalManagerService } from '../../../../_helpers/Modals/ModalManager.service';
import { MatPaginator, MatTableDataSource, MatSort } from '@angular/material';
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { DataSource } from '@angular/cdk/table';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators';
import { FormGroup, FormControl, NgForm, ReactiveFormsModule } from '@angular/forms';
//import { FormGroup, FormControl, NgForm,ReactiveFormsModule } from '@angular/forms';
import { FormBuilder, Validators, FormArray, FormControlName, NgModel } from '@angular/forms';
import { APIConstants } from '../../../../_config/restapis';
import { HttpClient } from '@angular/common/http';
import { MyDialogComponent } from '../../../../_helpers/Modals/my-dialog/my-dialog.component';

import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { saveAs as importedSaveAs } from "file-saver";


const today = new Date();
var time_today = today.getTime();
let now = new Date();
const currentdat = formatDate(now, 'dd-MM-yyyy', 'en-US', '+0530');
declare var require: any
let dateFormat = require('dateformat');
const currentdatee = formatDate(now, 'yyyy-MM-dd', 'en-US', '+0530');
export interface DialogData {
  setValue :string,
  setRole : string
  }
@Component({
  selector: 'app-principal-header-summary',
  templateUrl: './principal-header-summary.component.html',
  styleUrls: ['./principal-header-summary.component.css']
})
export class PrincipalHeaderSummaryComponent extends Lifecycle {

  newHeaders: number[] = [];
  newSummaries: number[] = [];
  rootHeaders: any[];
  allrootHeaders: any;
  allRootHeadersForApp: any;
  listallRootHeadersRJIO: any;
  isthiscomong: any;
  deactvResult: any;
  allRootHeadersForTSP: any;
  headerId: any;
  public principalEntityId: any;
  public entityRefNo: any;
  public role: any;
  newHeaderSummary: any;
  allHeaderSummary: any;
  param: any;
  principalEntityName: any;
  filterData: any;
  EntityClass: any;

  headStatusDLT: any;


  @ViewChildren(MatPaginator) paginator = new QueryList<MatPaginator>();
  @ViewChild('t1Sort') t1Sort: MatSort;
  @ViewChild('t2Sort') t2Sort: MatSort;
  @ViewChild('t3Sort') t3Sort: MatSort;
  @ViewChild('t4Sort') t4Sort: MatSort;
  @ViewChild('t6Sort') t6Sort: MatSort;
  @ViewChild('dataSourceHeaderSummaryDLTSort') dataSourceHeaderSummaryDLTSort: MatSort;
  numbersOfMatSort = 0;
  dataSubject = new BehaviorSubject<any[]>([]);
  // displayedColumns: string[] = ['H_PrincipalEntityId', 'TSP_Name', 'Header_Name', 'PrincipalEntityId', 'H_Register_Date', 'Hash_KYC_Doc', 'Approve', 'Reject'];
  displayedColumns: any[] = [
     'cli','htyp','mobileNumber', 'createdBy','entityname','OrgName','entityType', 'createdAt', 'sts',
    { def: 'Approve', showMobile: false },
    { def: 'Reject', showMobile: false },
  ];
  // displayedColumns1: string[] = ['RH_PrincipalEntityId', 'TSP_Name', 'Root_Header_Name', 'RH_Created_By', 'RH_Register_Date', 'Approve', 'Reject'];

  displayedColumns2: any[] = ['cli','hid','htyp','mobileNumber', 'createdBy','entityname','OrgName','entityType', 'cts', 'sts'
    // { def: 'Approve', showMobile: false }, changing now
    // { def: 'Reject', showMobile: false },
  ];
  displayedColumns5: any[] = ['cli','htyp','mobileNumber', 'createdBy','entityname','OrgName','entityType', 'createdAt', 'sts'
    // { def: 'Approve', showMobile: false }, changing now
    // { def: 'Reject', showMobile: false },
  ];
  // displayedColumns4: any[] = ['cli','hid','htyp','mobileNumber', 'PrincipalEntityId','entityname','OrgName','entityType', 'cts', 'sts', 'Active', 'BlackList'
    // // { def: 'Approve', showMobile: false },
    // // { def: 'Reject', showMobile: false },
  // ];
   displayedColumns4: any[] = ['cli','hid','htyp','mobileNumber', 'PrincipalEntityId','entityname','OrgName','entityType', 'cts', 'sts',
    // { def: 'Approve', showMobile: false },
    // { def: 'Reject', showMobile: false }, 
  ];
  displayedColumns3: string[] = ['RH_PrincipalEntityId', 'TSP_Name', 'Root_Header_Name', 'RH_Created_By', 'RH_Register_Date', 'RH_Status', 'Active'];
  dataSource: MatTableDataSource<any>;
  noRecord: any;
  dataSource1: MatTableDataSource<any>;
  noRecord1: any;
  dataSource2: MatTableDataSource<any>;
  noRecord2: any;
  dataSource3: MatTableDataSource<any>;
  noRecord3: any;
  dataSourceHeaderSummary: MatTableDataSource<any>;
  noRecord4: any;
  dataSourceHeaderSummaryDLT: MatTableDataSource<any>;
  noRecordHeaderSummaryDLT: any;
  dataSourceRHSummary: MatTableDataSource<any>;
  noRecord6: any;
  dataSourcependingRH: MatTableDataSource<any>;
  public newHeaderSummaryDLT: any;

  form: any = {};
  form1: any = {};
  form2: any = {};
  form3: any = {};
  entityRole = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_ROLE);



  openDialog(): void {
    const dialogRef = this.dialog.open(MyDialogComponent, {
      height: '400px',
      width: '600px'
    });
  }
  getDisplayedColumns(): string[] {

    //const isMobile = this.entityRole === 'Network Adminstrator' || 'Operations User';
    const isMobile = this.entityRole != 'Application Adminstrator';
    let a = this.displayedColumns
      .filter(cd => !isMobile || cd['showMobile'] !== false)
      .map(cd => typeof cd === 'string' ? cd : cd.def);

    return a;
  }

  downloadcsv(){ 

   
    this.hs.downloadcsv().subscribe(r => {
      const currentdat = formatDate(today.getTime(), 'medium', 'en-US', '+0530');

      var fileName ;
    
     
         fileName = currentdat+ ' Pending & Rejected Header Records.csv';
     
     
    importedSaveAs(r, fileName)
    //  this.downloadFile(r, Batch_Id);
      this.$modal.successModal({
        title: 'Entity Summary',
        msg: 'File has been downloaded Successfully'
      });   
    })
  
  }
  downloadcsvDLT(){

  this.hs.downloadcsvDLT().subscribe(r => {
    const currentdat = formatDate(today.getTime(), 'medium', 'en-US', '+0530');

    var fileName ;
  
   
       fileName = currentdat+ 'Header Records.csv';
   
   
  importedSaveAs(r, fileName)
  //  this.downloadFile(r, Batch_Id);
    this.$modal.successModal({
      title: 'Entity Summary',
      msg: 'File has been downloaded Successfully'
    });   
  })

}



  getDisplayedColumns2(): string[] {

    //const isMobile = this.entityRole === 'Network Adminstrator' || 'Operations User';
    const isMobile = this.entityRole != 'Application Adminstrator';
    let a = this.displayedColumns2
      .filter(cd => !isMobile || cd['showMobile'] !== false)
      .map(cd => typeof cd === 'string' ? cd : cd.def);

    return a;
  }


  constructor(
    private http: HttpClient,
    private hs: APIHeaderService,
    private db: $DBManagerService,
    private formBuilder: FormBuilder,
    public dialog: MatDialog,
    private $modal: $ModalManagerService) {
    super();
  }
  //filterForm: FormGroup;

  _initialize() {

    this.principalEntityId = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_ID);
    this.principalEntityName = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_NAME);
    this.entityRefNo = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_REF_NO_LOGIN);
    this.role = this.db.get(Constants.SESSSION_STORAGE, Constants.USER_ROLE);
    this.headerId = this.db.get(Constants.SESSSION_STORAGE, Constants.HEADER_ID);
	this.EntityClass = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_CLASS);
console.log("The entiy ref number is ",this.entityRefNo)
console.log("The pe number is ",this.principalEntityId)
var entityRefNoCancat = 1201 + this.entityRefNo;
//console.log("the entity ref number after concatentaiton is",entityRefNoCancat);
    // this.getAllRootHeaderForTSP();
    this.APIgetHeaderSummaryDLT();
    this.APIgetAllHeaderSummaries();
   

    // this.filterForm = this.formBuilder.group({
    //   principalEntity: ['', ],
    //   rtmNo: ['', [Validators.required]],
    //   templateName: ['', [Validators.required]],
    //   headerType: ['', [Validators.required]],
    //   modeOfComm: this.formBuilder.group({},Validators.required),
    //   timeBands: this.formBuilder.group({},),
    //   dayType: this.formBuilder.group({},),
    //   categories: ['',],
    //   uploadFile: ['', Validators.required],
    //   chooseHeader: ['', ],
    //   category: ['', ],
    // typeofcom:['',]
    // });



  }

  applyFilter(filterValue1: string) {
    this.dataSource.filter = filterValue1.trim().toLowerCase();
  }

  onApplyFilter(filterForm) {
    //console.log("inn");
    console.log("inn", filterForm);
    // let searchParam = this.filterForm.get("search").value;
    // let fdate = this.filterForm.get("startDate").value;
    // let todate =this.filterForm.get("endDate").value;
    // console.log("searchParam"+searchParam);

    console.log("inn2");
    console.log("serch", filterForm.search);
    console.log("2nd", filterForm.endDate);
    console.log("3rd", filterForm.startDate);

    const fdate = formatDate(filterForm.startDate, 'yyyy-MM-dd', 'en-US', '+0530');
    const ldate = formatDate(filterForm.endDate, 'yyyy-MM-dd', 'en-US', '+0530');
    console.log("fdate", fdate);
    console.log("ldate", ldate);
    // console.log("rd3",filterForm.endDate.value);
    this.getAllUnapprovedHeaderFilter(filterForm.search, fdate, ldate);
  }


  onApplyFilter2(filterForm2) {
    console.log("32rd", filterForm2.value);
    console.log("inn  allHeaders");
    const fdate = formatDate(filterForm2.startDate2, 'yyyy-MM-dd', 'en-US', '+0530');
    const ldate = formatDate(filterForm2.endDate2, 'yyyy-MM-dd', 'en-US', '+0530');

    this.getAllHeadersFilter(filterForm2.search2, fdate, ldate);
  }



  //MAke Active/Inactive Header

  makeActiveInactiveHeader(id, cli, sts) {

    if (sts == "A") {

      //	 this.rejectHeader(id,cli);
      var data = {
        "sts": "I",
        "entity_id": this.principalEntityId,
        "cli": cli,


      };
      console.log("data............... ", data);

      // this.newHeaderSummary = this.newHeaderSummary.data.filter(function (val, i) {
      this.newHeaderSummary = this.newHeaderSummary.filter(function (val, i) {
        return val._id !== id;
      });

      this.dataSource.data = this.newHeaderSummary;
     this.onChangeDataSource(this.newHeaderSummary);

      this.hs.approveHeader(data)
        .subscribe(r => {
          this.APIgetHeaderSummaryDLT();
          if (r.message == "Header Updated Succeessfully") {
            this.$modal.errorModal({
              title: 'Inactive Header',
              msg: 'Header has been made Inactive '
            });

          }
        })

    }
    else {
      let data = {
        "sts": "A",
       // "entity_id": this.entityRefNo,
       "entity_id": this.principalEntityId,
        "cli": cli,
      };
      console.log("this.newHeaderSummary.data............... ", this.newHeaderSummary.data);
  
  
      this.APIgetHeaderSummaryDLT();
      this.hs.approveHeader(data)
        .subscribe(async r => {
          console.log("response :", r);
          await this.APIgetHeaderSummaryDLT();
  
          if (r.message == "Header Updated Succeessfully") {
            // await this.APIgetHeaderSummaryDLT();
            this.$modal.successModal({
              title: 'Header Activation',
              msg: 'Header has been Activated'
            });
  
          }
          this.newHeaderSummary = this.newHeaderSummary.filter(function (val, i) {
            return val._id !== id;
          });
          this.onChangeDataSource(this.newHeaderSummary);
          console.log("this.newHeaderSummary ____ : ", this.newHeaderSummary);
          this.dataSource.data = this.newHeaderSummary;
          this.APIgetHeaderSummaryDLT();

        })

    }
  }

  //Approve Header
  approveHeader(id, cli,name,type) {
    let data = {
      "entityname":name,
      "entityType":type,
      "sts": "A",
     // "entity_id": this.entityRefNo,
     "entity_id": this.principalEntityId,

      "cli": cli,
    };
    console.log("data",data)
   


    this.newHeaderSummary = this.newHeaderSummary.filter(function (val, i) {
		console.log("removed entity is",id)
      return val._id !== id;
    });
    this.onChangeDataSource(this.newHeaderSummary);
    console.log("this.newHeaderSummary isss  ____ : ", this.newHeaderSummary);
    this.dataSource.data = this.newHeaderSummary;
    this.APIgetHeaderSummaryDLT();
    this.hs.approveHeader(data)
      .subscribe(async r => {
        console.log("response :", r);
        await this.APIgetHeaderSummaryDLT();

        if (r.status == true) {
          // await this.APIgetHeaderSummaryDLT();
          this.$modal.successModal({
            title: 'Header Registration',
            msg: 'Header has been Approved'
          });
          
        }
        // else {
        //   this.$modal.errorModal({
        //     title: 'Header Registration',
        //     msg: r.message
        //             });
        // }
        this.APIgetAllHeaderSummaries();
        this.APIgetHeaderSummaryDLT();
		 console.log("this.newHeaderSummary.data............... ", this.newHeaderSummary.data);
      })

  }


  //Approve Header
  rejectHeader(id, cli) {
    var data = {
      "sts": "R",
     // "entity_id": this.entityRefNo,
     "entity_id": this.principalEntityId,

      "cli": cli,


    };
    console.log("data............... ", data);

    // this.newHeaderSummary = this.newHeaderSummary.data.filter(function (val, i) {
    //  this.newHeaderSummary = this.newHeaderSummary.filter(function (val, i) {
    //   return val._id !== id;
    //  });

  //  this.dataSource.data = this.newHeaderSummary;
    //this.onChangeDataSource(this.newHeaderSummary);

    this.hs.approveHeader(data)
      .subscribe(r => {
      //  this.APIgetHeaderSummaryDLT();
        console.log("Rejected header")
        console.log(r)
        if (r.status == true ){
         console.log("r checking",r)
          this.$modal.errorModal({
            title: 'Header Registration',
            msg: 'Header has been Rejected '
          });
          console.log("this thing is coming")
         this.APIgetAllHeaderSummaries();
          
        }
      })


  }






  onChangeDataSource1(value) {
    this.dataSource1 = new MatTableDataSource(value);
    this.dataSource1.paginator = this.paginator.toArray()[1];
    this.dataSource1.sort = this.t2Sort;
    this.noRecord1 = this.dataSource1.connect().pipe(map(data => data.length === 0));
  }








  APIgetHeaderSummaryDLT() {
    if (this.role == "Tata Employee") {
      this.principalEntityId = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_ID);

      this.hs.ListHeaderSMSDLT().
        subscribe(val => {

          this.newHeaderSummaryDLT = val.data;

          console.log("this.newHeaderSummaryDLT ________,", this.newHeaderSummaryDLT);

          this.newHeaderSummaryDLT.map((vall, i) => {

            //this.newHeaderSummaryDLT[i].ops = vall.sts.JI
			this.newHeaderSummaryDLT[i].ops = vall.sts.TA

            // this.headStatusDLT = this.newHeaderSummaryDLT[i].sts.JI;
            // list.push(this.newHeaderSummaryDLT[i].sts.JI);
            this.onChangeDataSourceDLTHeader(this.newHeaderSummaryDLT);

          })



        });
    }
    else if (this.role == "PE") {
	
      // HEader Summary DLT

      this.hs.listPrincipalEntityHeaderSMSDLT(this.principalEntityId).subscribe(val => {

        this.newHeaderSummaryDLT = val.data;
        this.onChangedataSourceHeaderSummary(this.newHeaderSummaryDLT);
      })
    }

    else if (this.role == "TM") {
	
      this.hs.listTeleEntityHeaderSMSDLT(this.principalEntityId).subscribe(val => {
        this.newHeaderSummaryDLT = val.data;
        this.onChangedataSourceHeaderSummary(this.newHeaderSummaryDLT);

      });
    }
  }




  APIgetAllHeaderSummaries() {
    this.principalEntityId = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_ID);
    let entityRefNo = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_REF_NO_LOGIN);
    if (this.role == "Tata Employee") {
      this.hs.ListHeaderSMS().
        subscribe(value => {
          this.newHeaderSummary = value.data;
          this.onChangeDataSource(this.newHeaderSummary);
          console.log("this is first table",this.newHeaderSummary);
        });

    }
    else if (this.role == "PE") {
      this.param = this.entityRefNo;

      let data = {
       // "peid": this.entityRefNo
	    "peid": this.principalEntityId
      }
      this.hs.listPrincipalEntityHeaderSMS(data).subscribe(value => {
        //dataSorce2
        console.log("this.principalEntityIdthis.principalEntityIdthis.principalEntityIdthis.principalEntityIdthis.principalEntityId :", this.principalEntityId);
        console.log("VAlueeeeeeeee :", value);


        this.newHeaderSummary = value.data;
        this.onChangeDataSource(this.newHeaderSummary);
      })
    }
    else if (this.role == "TM") {

      let data = {
       // "tmid": this.entityRefNo
       "tmid": this.principalEntityId
      }
      this.hs.listTelemarketerEntityHeaderSMS(data).subscribe(value => {


        console.log("tele :", this.entityRefNo);
        this.newHeaderSummary = value.data;
        this.onChangeDataSource(this.newHeaderSummary);


      })

    }
  }

  

  //deactivate account method
 blacklistHeader(cli,tmid)
{

console.log("This is cli",cli)
var data={
	cli: cli
	}
  this.hs.deactivateHeaderService(data).subscribe( async result =>
  {
    await this.APIgetHeaderSummaryDLT();
    console.log("status--------------",result)
   // this.onChangeDataSourceDLTHeader(result);
	if(result.status == false)
	{
   
		this.$modal.errorModal({
            title: 'Entity Blacklist',
            msg: 'Error happened while Blacklisting an Entity '
          });
	}
       else if(result.status == true)
      {
    
		this.$modal.successModal({
            title: 'Entity Blacklist',
            msg: 'Successfully blacklisted entity'
          });
          await this.APIgetHeaderSummaryDLT();
      }

  })
}

  onChangeDataSource(value) {

    this.dataSource = new MatTableDataSource(value);
    this.dataSource.paginator = this.paginator.toArray()[0];

    this.dataSource.sort = this.t1Sort;
    this.noRecord = this.dataSource.connect().pipe(map(data => data.length === 0));

  }
  //For Header Summary DLT
  onChangeDataSourceDLTHeader(value) {
 
    this.dataSourceHeaderSummaryDLT = new MatTableDataSource(value);
    //this.dataSourceHeaderSummaryDLT.paginator = this.paginator.toArray()[1];
    this.dataSourceHeaderSummaryDLT.paginator = this.paginator.toArray()[0];
    this.dataSourceHeaderSummaryDLT.sort = this.dataSourceHeaderSummaryDLTSort;
    this.noRecordHeaderSummaryDLT = this.dataSourceHeaderSummaryDLT.connect().pipe(map(data => data.length === 0));

  }
  onChangedataSourceHeaderSummary(value) {

    this.dataSourceHeaderSummary = new MatTableDataSource(value);
    this.dataSourceHeaderSummary.paginator = this.paginator.toArray()[1]; 

    this.dataSourceHeaderSummary.sort = this.t4Sort;
    this.noRecord4 = this.dataSourceHeaderSummary.connect().pipe(map(data => data.length === 0));

  }
  getAllUnapprovedHeaderFilter(param1, fdate, todate) {


    console.log("inside main function " + param1 + "$$$" + fdate + "$$$$" + todate);
    this.hs.getAllUnApprovedHeadersFilter(param1, fdate, todate)
      .subscribe(r => {
        this.filterData = r;
        // this.dataSource = r;
        console.log("12345 :", this.filterData);
      })

  }

  getAllHeadersFilter(param1, fdate, todate) {
    console.log("inside main function ");

    console.log("inside main function " + param1 + "$$$" + fdate + "$$$$" + todate);
    this.hs.getAllHeadersFilter(param1, fdate, todate)
      .subscribe(r => {
        this.filterData = r;
        this.dataSource2 = r;
        console.log("12345 :", this.filterData);
      })

  }



  reset() {

    this.APIgetHeaderSummaryDLT();
    console.log("first reset function");

  }

  reset2() {

    this.APIgetAllHeaderSummaries();
    console.log("first reset function");

  }
  reset3() {

    //this.getAllRootHeaderForTSP();
    console.log("first reset function");

  }
  _destroy() { }
}

export class MyDataSource extends DataSource<any[]> {

  constructor(private subject: BehaviorSubject<any[]>) {
    super();
  }
  connect(): Observable<any[]> {
    return this.subject.asObservable();
  }
  disconnect(): void {

  }

}
